import {IPresentation} from '../presentation';
import {IRunfileIdentification} from './room.editor';
import {ProtectionType} from '../presentationProtection';

export interface IFetchRoom {
    roomId: string;
    roomStatus: RoomStatus;
    presentationId: string;
    presenterId: string;
    isAllowed: boolean;
    isOwner?: boolean;
    isPresenter: boolean;
    roomRunFileId: string;
    presentation: IPresentation;
    identification?: IRunfileIdentification;
    showLeaderboard?: boolean;
    startTime?: string;
    endTime?: string;
    socketToken?: string;
}

export interface IFetchRoomProtection {
    protectionTypes: ProtectionType[];
    isRoomPresenterAnonymous?: boolean;
    isRoomActive?: boolean;
    identificationLabel?: string;
}

export enum RoomStatus {
    IDLE = 'IDLE',
    LOBBY = 'LOBBY',
    PLAYING = 'PLAYING',
}
